import './component';
import './page';
import './scss/base.scss';
import './service/trustpilot-api.service';
import './service/trustpilot-configuration.service';
import './service/trustpilot-recover-invitation.service';
import './state/trustpilot.store';
import '../../view/ecocode-trustpilot-sales-channel';
import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';


export const ERRORS = {
    INVALID_VALUE_COLOR_CODE: 'red'
};

const GENERIC_PRIVILEGE = 'system.plugin_maintain';

Shopware.Module.register('ecocode-trustpilot', {

    type: 'plugin',
    name: 'Trustpilot',
    title: 'ecocode-trustpilot.module.title',
    description: 'ecocode-trustpilot.module.description',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#FFD700',
    icon: 'default-object-lab-flask',
    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },
    routes: {
        setup: {
            component: 'ecocode-trustpilot-first-run-wizard',
            path: 'setup',
            meta: {
                privilege: GENERIC_PRIVILEGE
            },
            redirect: {
                name: 'ecocode.trustpilot.setup.welcome',
                meta: {
                    privilege: GENERIC_PRIVILEGE
                }
            },
            children: {
                welcome: {
                    component: 'ecocode-trustpilot-welcome',
                    path: 'welcome',
                    meta: {
                        privilege: GENERIC_PRIVILEGE
                    }
                },
                connect: {
                    component: 'ecocode-trustpilot-connect',
                    path: 'connect',
                    meta: {
                        privilege: GENERIC_PRIVILEGE
                    }
                },
                configure: {
                    component: 'ecocode-trustpilot-configure',
                    path: 'configure',
                    meta: {
                        privilege: GENERIC_PRIVILEGE
                    }
                },
                invitation: {
                    component: 'ecocode-trustpilot-invitation',
                    path: 'invitation',
                    meta: {
                        privilege: GENERIC_PRIVILEGE
                    }
                },
                finish: {
                    component: 'ecocode-trustpilot-finish',
                    path: 'finish',
                    meta: {
                        privilege: GENERIC_PRIVILEGE
                    }
                }
            }
        },
        overview: {
            component: 'ecocode-trustpilot-overview',
            path: 'overview'
        }
    },
    navigation: [{
        id: 'ecocode-trustpilot',
        icon: 'default-object-marketing',
        color: '#FFD700',
        path: 'ecocode.trustpilot.overview',
        label: 'ecocode-trustpilot.general.mainMenuLabel',
        parent: 'sw-marketing',
        privilege: GENERIC_PRIVILEGE
    }],
    routeMiddleware(next, currentRoute) {
        if (currentRoute.name === 'sw.sales.channel.detail') {
            currentRoute.children.push({
                name: 'sw.sales.channel.detail.trustpilot',
                path: '/sw/sales/channel/detail/:id/trustpilot',
                component: 'ecocode-trustpilot-sales-channel',
                meta: {
                    privilege: GENERIC_PRIVILEGE
                }
            });
        }
        next(currentRoute);
    }
});
